import { JobQueueStatus, ZipJobsResponseModel } from "@app/jobs";
import { JobListSummary } from "@app/jobs/jobListSummary";
import { ServiceBase } from "@app/shared";
import { querystringify } from "@app/shared/utility";
import { SortDirections } from "@app/shared/waffles";
import Job, { JobStatus } from "./job";

export default class JobService extends ServiceBase {
  public async getJobStatusesByCustomProjectIdAsync(projectId: number): Promise<JobQueueStatus[]> {
    return await this.makeGet<JobQueueStatus[]>(`jobs/queue-status/project/${projectId}`);
  }

  public async getZipJobStatusesByCustomProjectIdAsync(projectId: number): Promise<ZipJobsResponseModel[]> {
    return await this.makeGet<ZipJobsResponseModel[]>(`jobs/queue-status/zip-project/${projectId}`);
  }

  public async getJobListSummary(skip: number, take: number, sortDirection?: SortDirections, sortedColumn?: string, numDays?: number,
    jobTypeFilter?: string, jobStatusDateFilter?: string, jobQueueFilter?: string, clientFilter?: string, projectIdFilter?: number, projectNameFilter?: string,
    selectedJobStatusItems?: Array<JobStatus>, allowDirtyReads?: boolean): Promise<JobListSummary> {
    const query = {
      allowDirtyReads: allowDirtyReads ?? false,
      clientFilter: clientFilter,
      jobQueueFilter: jobQueueFilter,
      jobStatusDateFilter: jobStatusDateFilter,
      jobTypeFilter: jobTypeFilter,
      numDays: numDays,
      offset: skip,
      pageSize: take,
      projectIdFilter: projectIdFilter,
      projectNameFilter: projectNameFilter,
      selectedJobStatusItems: selectedJobStatusItems,
      sortDirection: sortDirection,
      sortedColumn,
    };

    return await this.makeGet<JobListSummary>(`jobs/summary?${querystringify(query)}`);
  }

  public async getJobById(jobId: number, allowDirtyReads?: boolean): Promise<Job> {
    const query = {
      allowDirtyReads: allowDirtyReads ?? false
    }

    return await this.makeGet<Job>(`jobs/${jobId}?${querystringify(query)}`);
  }


  public async cancelStartedJobById(jobIds: number[], resubmit: boolean): Promise<void> {
    const body = {
      jobIds: jobIds
    }
    const query = {
      resubmit: resubmit
    }
    return await this.makePatch<void>(`jobs/cancel-running?${querystringify(query)}`, body);
  }

  public async cancelQueuedJobById(jobIds: number[]): Promise<void> {
    const body = {
      jobIds: jobIds
    }
    return await this.makePatch<void>(`jobs/cancel-queued`, body);
  }

  public async changeJobQueue(jobIds: number[], newQueue: string): Promise<void> {
    const body = {
      jobIds: jobIds
    }
    const query = {
      newQueueName: newQueue
    }
    console.log("inside of jobService.ts, the newQueue is: " + newQueue);
    return await this.makePatch<void>(`jobs/change-queue?${querystringify(query)}`, body);
  }
}
